import styles from "./ArticleTitle.module.scss";
import cx from "classnames";
import { ArticleTitleFragment, ArticleLayout } from "types/api";
import { gql } from "utils/urql";

const ArticleTitle = ({ title, layout }: ArticleTitleFragment) => {
  return (
    <h1
      className={cx(
        styles.root,
        (layout === ArticleLayout.Feature || layout === ArticleLayout.Twocol) &&
          styles.featureOrTwoCol,
        layout === ArticleLayout.Twocol && styles.twoCol
      )}
      dangerouslySetInnerHTML={{ __html: title }}
    />
  );
};

ArticleTitle.fragment = gql`
  fragment articleTitle on Article {
    title
    layout
  }
`;

export default ArticleTitle;
